// extracted by mini-css-extract-plugin
export default {"main":"SearchPaneView_main__Ha+qT","userCardContainer":"SearchPaneView_userCardContainer__-0JW1","noResults":"SearchPaneView_noResults__bs-tT"};